import React, { useCallback, useEffect, useState } from 'react'
import { debounce, IconButton, InputAdornment, TextField } from '@mui/material'
import SearchIcon from '@mui/icons-material/Search'

const SearchBar = ({ value, onChange }) => {
  const [searchInput, setSearchInput] = useState(value)

  // eslint-disable-next-line
  const debounceSearch = useCallback(
    debounce((newValue) => {
      onChange(newValue)
    }, 200),
    [onChange]
  )

  useEffect(() => {
    debounceSearch(searchInput)
  }, [searchInput, debounceSearch])

  return (
    <TextField
      value={searchInput}
      onChange={(event) => setSearchInput(event.target.value)}
      label='Search'
      fullWidth
      InputProps={{
        endAdornment: (
          <InputAdornment position='start'>
            <IconButton onClick={() => onChange(searchInput)}>
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
}

export default SearchBar
